// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiBaseUrl: 'https://smartpart-edge-demo.firebaseapp.com/api/',
    algoliaAppId: '',
    firebase: {
        apiKey: 'AIzaSyDtUH9TaZIEXNYvJnqO6ROr43JafVzMERI',
        authDomain: 'smartpart-edge-demo.firebaseapp.com',
        databaseURL: 'https://smartpart-edge-demo.firebaseio.com',
        projectId: 'smartpart-edge-demo',
        storageBucket: 'smartpart-edge-demo.firebasestorage.app',
        messagingSenderId: '844621515332',
        appId: '1:844621515332:web:cda37c62de5b55c5'
    }
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
